import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const contactListState = (state: AppState) => state.contactsAndOrganizations.contacts.contactList;

export const contactListItemsSelector = createSelector(contactListState, state => state.items);
export const contactListRequestingSelector = createSelector(contactListState, state => state.requesting);
